import { useNavigate } from 'react-router-dom';
import Button from './inputs/Button';

interface PermissionModalProps {
  module?: string;
}

export default function PermissionModal({ module = 'Activation' }: PermissionModalProps) {
  const navigate = useNavigate();

  const handleBackToDashboard = () => {
    navigate('/dashboard');
  };

  return (
    <div className="fixed inset-0 z-50 flex justify-center items-center">
      {/* Background Overlay - Grayed out */}
      <div className="absolute inset-0 bg-black bg-opacity-50" />

      {/* Modal Panel */}
      <div className="relative z-50 flex flex-col w-11/12 md:w-2/3 lg:w-1/2 max-w-lg bg-white rounded-lg shadow-lg overflow-hidden">

        {/* Modal Header */}
        <div className="flex justify-center items-center p-6 border-b flex-shrink-0">
          <h4 className="text-xl font-semibold text-gray-800">Permission Required</h4>
        </div>

        {/* Modal Content */}
        <div className="flex-grow p-6 text-center">
          <p className="text-gray-600 mb-6">
            The {module} module isn't active on your account. Want to learn more? Contact your admin or support team.
          </p>
        </div>

        {/* Modal Footer */}
        <div className="flex justify-center p-6 border-t flex-shrink-0">
          <Button
            onClick={handleBackToDashboard}
            className="w-full"
            primary
            type="button"
          >
            Back to Dashboard
          </Button>
        </div>
      </div>
    </div>
  );
}